import { render, staticRenderFns } from "./SiatLetturaPianiAssegnatiComponent.vue?vue&type=template&id=5d241e9c&scoped=true"
import script from "./SiatLetturaPianiAssegnatiComponent.vue?vue&type=script&lang=js"
export * from "./SiatLetturaPianiAssegnatiComponent.vue?vue&type=script&lang=js"
import style0 from "./SiatLetturaPianiAssegnatiComponent.vue?vue&type=style&index=0&id=5d241e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d241e9c",
  null
  
)

export default component.exports